import { IYieldCompounding } from '~/@api/generated-api-types-project/Api'

export function getProjectInvestmentPeriodString(
  investmentPeriod: number,
  yieldCompounding?: IYieldCompounding
) {
  return yieldCompounding === IYieldCompounding.Annually &&
    investmentPeriod > 12
    ? `12 - ${investmentPeriod}`
    : `${investmentPeriod}`
}
